export function sendGa(event = '', data = {}) {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      'event': event,
      ...data,
    });
  }
}
